import { Injectable } from '@angular/core';
// import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { AppStateService } from './app-state.service';
import { AuthenticationService } from '../modules/authentication/services/authentication.service';
import { EnvService } from './env.service';
import { UtilsService } from './utils.service';
import { isNullOrUndefined } from '../modules/shared';
import Keycloak, { KeycloakLoginOptions } from 'keycloak-js';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private loginFlag!: boolean;
  private keyCloakLoginOpts!: KeycloakLoginOptions;
  private keyCloakAuth!: Keycloak;
  // private currentResourceName: string | null = null;
  // private isOneOfPredefinedResources: boolean = false;
  private unsubscribe$ = new Subject<void>();

  constructor(
    // private router: Router,
    private appState: AppStateService,
    private keyCloakSrv: KeycloakService,
    private authSrv: AuthenticationService,
    private envService: EnvService,
    private utilService: UtilsService,
    // private homeService: HomeService
  ) {}

  public async initiateLogin(): Promise<void> {


    const isLoggedIn = await this.isUserLoggedIn();
    this.loginFlag = !!isLoggedIn;

    if (!this.loginFlag) {
      await this.utilService.logout(true);
    }
    this.keyCloakLoginOpts = {
      redirectUri: this.envService.keyCloakUrls.redirectUrl,
    };

    this.authSrv.authState.pipe(takeUntil(this.unsubscribe$)).subscribe((state) => {
      this.loginFlag = state;
      
      if (this.loginFlag) {
        this.keyCloakAuth = this.appState.getKeyCloakInstance()
          ? this.appState.getKeyCloakInstance()
          : this.keyCloakSrv.getKeycloakInstance();

        if (isNullOrUndefined(this.appState.getKeyCloakInstance())) {
          this.appState.setKeyCloakInstance(this.keyCloakAuth);
        }
      }
    });

    await this.login();

    // Clean up subscriptions after login
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private async isUserLoggedIn(): Promise<boolean> {
    return this.keyCloakSrv.isLoggedIn();
  }

  private async login(): Promise<void> {
    await this.keyCloakSrv.login(this.keyCloakLoginOpts);
  }
}
